import { useCallback, useMemo } from 'react';
import Amplitude from 'utils/amplitude';
import usePlaidLink from 'hooks/usePlaidLink';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { useAppSelector, useAppStore } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useOnboarding from 'features/pots/hooks/useOnboarding';
import { completeSetupStepsSelector } from './selectors';
import { CompleteSetupStepId } from './entities';
export const useCompleteSetupSteps = (analyticsName = 'Opened Card Setup Item') => {
    const navigation = useMainStackNavigation();
    const { navigateToTab } = useTabNavigation();
    const store = useAppStore();
    const openPlaid = usePlaidLink();
    const navigateToAddBankConnection = useCallback(() => {
        const { user: { user }, } = store.getState();
        if (user.guessedHomeCountry !== 'GB') {
            openPlaid();
        }
        else {
            navigation.navigateDeprecated('ChooseBank', {
                back: true,
                personal: true,
            });
        }
    }, [openPlaid, store]);
    const [openPotsOnboarding] = useOnboarding();
    const onStepPress = useCallback((step) => {
        if (step.analyticsTag) {
            Amplitude.logEvent(analyticsName, {
                type: step.analyticsTag,
            });
        }
        switch (step.id) {
            case CompleteSetupStepId.ACTIVATE_TRIAL:
                navigation.navigateDeprecated('EmmaProModal', {});
                break;
            case CompleteSetupStepId.SECOND_BANK_ACCOUNT:
                navigateToAddBankConnection();
                break;
            case CompleteSetupStepId.SET_UP_BUDGETING:
                navigation.navigateDeprecated('SetUpBudget', {});
                break;
            case CompleteSetupStepId.START_INVESTING:
                navigateToTab('Invest');
                break;
            case CompleteSetupStepId.START_SAVING:
                openPotsOnboarding();
                break;
            case CompleteSetupStepId.CREDIT_SCORE:
                navigation.navigate('CreditScoreOnboarding');
                break;
            case CompleteSetupStepId.RENT_REPORTING:
                navigation.navigateDeprecated('RentReportingOnboarding');
                break;
            case CompleteSetupStepId.FRAUD_DETECTION:
                navigation.navigateDeprecated('FraudProtectionIntro');
                break;
            default:
                break;
        }
    }, [
        analyticsName,
        navigateToAddBankConnection,
        navigateToTab,
        openPotsOnboarding,
    ]);
    const steps = useAppSelector(completeSetupStepsSelector);
    const stepsToComplete = useMemo(() => steps.filter((step) => !step.isCompleted), [steps]);
    return {
        availableCount: steps.length,
        completedCount: steps.length - stepsToComplete.length,
        stepsToComplete,
        onStepPress,
    };
};
